import { SupportTicketMessage, SupportTicketFile } from "src/api/rtk/indorsoftRu/slices/supportApiSlice";
import { formatBitrixMoscowToUserTimeHHmm } from "src/shared/format/date";
import { renderSupportMessage } from "src/shared/renderers/renderSupportMessage";
import { getSupportTicketFileUrl, isImageFile, formatFileSize } from "../utils/supportTicketUtils";
import css from "../SupportTicketPage.module.scss";

type MessageItemProps = {
    message: SupportTicketMessage;
    isFirstNewSupportMessage: boolean;
    newMessagesLabelRef?: React.RefObject<HTMLLIElement>;
};

export default function MessageItem({ 
    message, 
    isFirstNewSupportMessage, 
    newMessagesLabelRef 
}: MessageItemProps) {
    const isUserMessage = message.MESSAGE_BY_SUPPORT_TEAM !== "Y";

    return (
        <>
            {isFirstNewSupportMessage && (
                <li
                    key={`new-messages-divider-${message.ID}`}
                    ref={newMessagesLabelRef}
                    className={css.newMessagesDivider}
                >
                    <div className={css.newMessagesLabel}>
                        Новые сообщения
                    </div>
                </li>
            )}
            <li
                key={message.ID}
                data-message-id={message.ID}
                data-message-by-support={message.MESSAGE_BY_SUPPORT_TEAM}
                className={`${css.messageItem} ${
                    isUserMessage ? css.messageItemUser : css.messageItemSupport
                }`}
            >
                <div className={css.messageInner}>
                    <div
                        className={`${css.messageAvatar} ${
                            isUserMessage ? css.messageAvatarUser : css.messageAvatarSupport
                        }`}
                    >
                        {isUserMessage ? "Я" : "П"}
                    </div>
                    <div className={css.messageBubble}>
                        {message.IS_HIDDEN === "Y" && (
                            <div className={css.messageHeader}>
                                <span className={css.messageHidden}>
                                    Скрытое сообщение
                                </span>
                            </div>
                        )}
                        <div className={css.messageBody}>
                            {renderSupportMessage(message.MESSAGE)}
                        </div>
                        {message.FILES && message.FILES.length > 0 && (
                            <ul className={css.filesList}>
                                {message.FILES.map((file: SupportTicketFile) => {
                                    const fileUrl = getSupportTicketFileUrl(file.HASH);
                                    const isImage = isImageFile(file);

                                    return (
                                        <li key={file.ID} className={css.fileItem}>
                                            <a
                                                href={fileUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                                className={css.fileLink}
                                            >
                                                {isImage && (
                                                    <img
                                                        src={fileUrl}
                                                        alt={file.NAME}
                                                        className={css.fileImagePreview}
                                                    />
                                                )}
                                                <div className={css.fileInfo}>
                                                    <span className={css.fileName}>
                                                        {file.NAME}
                                                    </span>
                                                    {file.FILE_SIZE && (
                                                        <span className={css.fileSize}>
                                                            {formatFileSize(file.FILE_SIZE)}
                                                        </span>
                                                    )}
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        <span className={css.messageTime}>
                            {formatBitrixMoscowToUserTimeHHmm(message.DATE_CREATE)}
                        </span>
                    </div>
                </div>
            </li>
        </>
    );
}


